import {
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_ERROR,
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_START,
  READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS,
} from 'constants/action-types/loanRequests/microLoanNotifications';

export default (state, { type, payload }) => {
  switch (type) {
    case READ_ALL_MICRO_LOAN_NOTIFICATIONS_START:
      return {
        ...state,
        readAllMicroLoanNotifications: {
          ...state.readAllMicroLoanNotifications,
          loading: true,
          error: null,
        },
      };
    case READ_ALL_MICRO_LOAN_NOTIFICATIONS_ERROR:
      return {
        ...state,
        readAllMicroLoanNotifications: {
          ...state.readAllMicroLoanNotifications,
          error: payload,
          loading: false,
        },
      };
    case READ_ALL_MICRO_LOAN_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        readAllMicroLoanNotifications: {
          ...state.readAllMicroLoanNotifications,
          data: payload.data,
          error: null,
          loading: false,
        },
      };
    default:
      return null;
  }
};
